import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { FilterStates } from '../../../../components/candidate_experience/Filters/filterState';
import { BenchmarkType } from '../../../../entities/candidate_experience/BenchmarkType';
import { PageWideSpinner } from '../../../../components/PageWideSpinner';
import { InterviewerAnalyticsService } from '../../../../services/candidate_experience/InterviewerAnalyticsService';
import { InterviewerAnalytics } from '../../../../entities/candidate_experience/InterviewerAnalytics';

import {
  generateQueryString,
  setFilters,
} from '../../../../components/candidate_experience/Filters/urlHelper';
import { InterviewerPulseAnalytics } from './InterviewerPulseAnalytics';

/**
 * Props needed at initial rendering time. Made immediately available by
 * the backend.
 */
interface PagePropTypes {
  benchmark_types: BenchmarkType[];
  activeTab: string;
}

export default function InterviewerPulseTab(props: PagePropTypes) {
  const initFilters = {
    benchmarkTypes: props.benchmark_types,
  };

  const [searchParams, setSearchParams] = useSearchParams();
  const [filterStates, setFilterStates] = useState<FilterStates>(
    setFilters(initFilters, searchParams),
  );
  const [showMoreFilters, setShowMoreFilters] = useState(false);
  const [analytics, setAnalytics] = useState<InterviewerAnalytics>(null);

  function handleApplyFilter(filterStates: FilterStates, moreFilters: boolean) {
    setFilterStates(filterStates);
    setShowMoreFilters(moreFilters);
  }

  useEffect(() => {
    setAnalytics(null);

    const filterSelector = filterStates.filterSelector.selected.value;
    setSearchParams(generateQueryString(filterStates));

    InterviewerAnalyticsService.get(
      filterSelector,
      filterStates.jobs.selected.map((option) => option.value),
      filterStates.departments.selected.map((option) => option.value),
      filterStates.benchmarkType.selected.value,
      filterStates.dateRange,
    ).then((analytics) => setAnalytics(analytics));
  }, [filterStates]);

  if (analytics === null) {
    return <PageWideSpinner />;
  }

  return (
    <InterviewerPulseAnalytics
      analytics={analytics}
      filterStates={filterStates}
      onApplyFilter={handleApplyFilter}
      showMoreFilters={showMoreFilters}
    />
  );
}
